/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import LoadAndDisplay from "@/context/LoadAndDisplay";
import Pagination from "./Pagination";
import { useRouter } from "next/router";
import DataNotFound from "../NotFound/DataNotFound";

const DataDisplay = ({
  fetchData,
  children,
  user,
  config,
  empty,
  entryLimit,
}) => {
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [limit, setLimit] = useState({
    value: entryLimit || 20,
    label: entryLimit || "20",
  });
  const [searchBy, setSearchBy] = useState(
    config?.searchBy ? config?.searchBy : "displayName"
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [error, setError] = useState(null);
  const router = useRouter();

  useEffect(() => {
    if (user && router) {
      fetchData(
        currentPage,
        limit.value,
        search,
        searchBy,
        setPages,
        setError,
        setLoading
      );
    }
  }, [user, currentPage, limit, search, searchBy]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    fetchData(
      currentPage,
      limit,
      search,
      searchBy,
      setPages,
      setError,
      setLoading
    );
    setCurrentPage(1);
  };

  return (
    <div className="row g-5">
      {!empty && (
        <form
          onSubmit={handleSearchSubmit}
          className="d-flex align-items-center gap-5"
        >
          <input
            type="text"
            placeholder="Type to search..."
            value={search}
            onChange={handleSearchChange}
          />
          <button type="submit" className="rbt-search-btn rbt-round-btn">
            <i className="feather-search"></i>
          </button>
        </form>
      )}

      <LoadAndDisplay isLoading={loading}>{children}</LoadAndDisplay>
      {error && <p className="text-danger">{error}</p>}
      {empty ? (
        <DataNotFound {...config?.empty} />
      ) : (
        pages > 1 && (
          <Pagination
            totalPages={pages}
            pageNumber={currentPage}
            handleClick={setCurrentPage}
            maxItems={limit}
            setMaxItems={setLimit}
          />
        )
      )}
    </div>
  );
};

export default DataDisplay;
